import { groq } from '#imports';

export function getQuery() {
  return groq`*[_type == "zRatingSpecial" && !(_id in path('drafts.**'))]{
    name,
    title,
    image,
    content,
    allCards {
        commonRatingCards[]->{
            name,
            image,
            score,
            _createdAt,
            _updatedAt,
            publishedAt
        },
        positionRatingCards[]->{
            name,
            image,
            score,
            _createdAt,
            _updatedAt,
            publishedAt
        },
        propagandaRatingCards[]->{
            name,
            image,
            score,
            _createdAt,
            _updatedAt,
            publishedAt
        },
        forcingRatingCards[]->{
            name,
            image,
            score,
            _createdAt,
            _updatedAt,
            publishedAt
        },
        pushingRatingCards[]->{
            name,
            image,
            score,
            _createdAt,
            _updatedAt,
            publishedAt
        }
    },
    graph,
    methodology,
    ogImage
}[0]
`;
}
